import styled from 'styled-components';

const BSEContainer = styled.div`
  width: 100%;
  display: flex;
  // justify-content: center;
`;

const Container = styled.div`
  .MLR {
    margin-left: 13px;
    margin-right: 13px;
  }
  // // li::before {
  //   content: '•';
  //   padding-right: 5px;
  // }

  ul li {
    list-style: disc;
  }

  ol li {
    list-style: decimal;
  }

  .COLOR {
    color: #4f6168;
    margin-left: 26px;
  }
  .MR {
    margin-right: 8px;
  }
  .MRA {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #5b36f2;
  }

  .colorPurple {
    color: #1a055d;
  }

  .Urlcolor {
    color: #5b36f2;
    margin-left: 2px;
  }

  .PL {
    padding-left: 16px;
  }

  .PLbody {
    padding-left: 22px;
  }

  .statusDiv {
    margin-bottom: 8px;
  }
  @media (min-width: 640px) {
    .statusDiv {
      margin-bottom: 0px;
    }
  }
`;

const Title = styled.h2`
  height: 28px;
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 28px;
  color: #161d1f;
  margin-top: 14px;
  margin-bottom: 8px;
`;

const SubTitle = styled.div`
  justify-content: flex-start;
  margin-bottom: 16px;
  .RowA {
    display: flex;
    padding-top: 6px;
  }

  .HiddenContent {
    visibility: hidden;
  }
  @media (min-width: 640px) {
    display: flex;
    align-items: flex-end;
    .HiddenContent {
      visibility: visible;
    }
  }
`;

const SubIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-text02);
`;

const BodyContent = styled.div`
  background: #ffffff;
  width: 100%;
  border-radius: 8px;
`;

const UtpButton = styled.a`
  &.link-underline {
    text-decoration: underline;
    padding: 1px;
  }
  /* height: 30px; */

  &.Urlcolor {
    color: #5b36f2;
    margin-left: 2px;
    &:focus {
      color: #4318cd;
      border-radius: 4px;
      border: 1px solid #4318cd;
    }
    &:hover {
      border: 1px solid #745ef6;
    }
    &:active {
      border: 1px solid #4318cd;
    }
  }

  &:hover {
    cursor: pointer;
    outline: none;
    color: #745ef6;
  }
  &:focus {
    outline: none;
    color: #4318cd;
    border: 1px solid #4318cd;
    border-radius: 4px;
    padding: 4px 2px;
    p {
      border-bottom: 1px solid #4318cd;
    }
  }
  &:active {
    border: 1px solid #4318cd;
    border-radius: 4px;
    p {
      border-bottom: 1px solid #4318cd;
    }
  }
`;
const BodyContent2 = styled.div.attrs((props: any) => ({
  margin: props.margin
}))`
  margin: ${(props) => props.margin};
`;
const BodyTitle = styled.div.attrs((props: any) => ({
  margin: props.margin,
  paddingTop: props.paddingTop
}))`
  display: flex;
  align-items: flex-start;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  // margin: 20px 16px 8px 16px;
  // padding-top: 20px;
  margin: ${(props) => props.margin};
  padding-top: ${(props) => props.paddingTop};
  b {
    color: #1a055d;
  }
  @media (min-width: 640px) {
    align-items: center;
  }
`;

const Question = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f;
  margin-bottom: 12px;
`;

const BodyText = styled.li`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f;
`;

const BodyUrl = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-top: 12px;
  margin-bottom: 16px;
`;

const IconArrow = styled.div.attrs((props: any) => ({
  margin: props.margin
}))`
  display: flex;
  align-items: flex-start;
  // margin: 10px 16px 10px 16px;
  margin: ${(props) => props.margin};
  padding-bottom: 16px;
  @media (min-width 640px) {
    display: flex;
    align-items: center;
  }
`;

const Footer = styled.div`
  width: 100%;
  height: 100%;
  // padding: 16px;
`;

const ArrowFooter = styled.button`
  display: flex;
  align-items: center;
  padding: 10px 11px;
  margin: 14px 8px 18px -13px;
  border-radius: 4px;
  &:hover {
    background: #e2dffd;
  }
  &:focus {
    background: #c6c0fc;
  }
  &:active {
    background: #c6c0fc;
  }
`;

const TextFooter = styled.li`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

const TextButton = styled.button`
  width: 100%;
  padding: 10px 16px;
  background: #5b36f2;
  border-radius: 4px;
  color: #ffffff;
  margin-top: 35px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  &:hover {
    background: #745ef6;
    cursor: pointer;
  }
  &:focus {
    background: #4318cd;
  }
  &:active {
    background: #4318cd;
  }
  @media (min-width: 640px) {
    width: 145px;
  }
  @media (min-width: 992px) {
    margin-bottom: 57px;
  }
`;
export {
  BSEContainer,
  Container,
  Title,
  SubTitle,
  SubIcon,
  UtpButton,
  BodyContent,
  BodyTitle,
  Question,
  BodyText,
  BodyUrl,
  BodyContent2,
  IconArrow,
  Footer,
  ArrowFooter,
  TextFooter,
  TextButton
};
